import { UserPlus, Settings, Zap } from 'lucide-react';

const steps = [
  {
    num: 1,
    icon: UserPlus,
    title: 'Set up your organization',
    desc: 'Create your account, configure membership tiers, and import your existing member data. CSV import handles thousands of records in seconds.',
  },
  {
    num: 2,
    icon: Settings,
    title: 'Configure your workflows',
    desc: 'Set up automated dues invoicing, renewal reminders, onboarding emails, and committee structures. Customize everything to match how your organization operates.',
  },
  {
    num: 3,
    icon: Zap,
    title: 'Launch and grow',
    desc: 'Members join through your branded portal, pay dues online, register for events, and access resources. You focus on your mission while the platform handles the admin.',
  },
];

export function HowItWorksSection() {
  return (
    <section id="how-it-works" className="relative py-28 sm:py-32">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 50% 30% at 50% 0%, rgba(20,184,166,0.06) 0%, transparent 70%)',
        }}
      />

      <div className="relative mx-auto max-w-5xl px-6">
        <div className="mb-16 text-center reveal">
          <span className="mb-4 inline-block rounded-full border border-ams-700/40 bg-ams-950/40 px-3 py-1 text-xs font-medium text-ams-400">
            How It Works
          </span>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Up and Running in Under an Hour
          </h2>
          <p className="mx-auto max-w-2xl text-zinc-400">
            No consultants. No 6-month implementation. Import your data, configure your settings, and go live.
          </p>
        </div>

        <div className="grid gap-8 sm:gap-10 md:grid-cols-3">
          {steps.map((step) => (
            <div key={step.num} className="reveal text-center">
              <div className="mx-auto mb-6 step-number">{step.num}</div>
              <div className="mb-3 flex items-center justify-center gap-2">
                <step.icon className="h-4 w-4 text-ams-400" />
                <h3 className="text-lg font-semibold">{step.title}</h3>
              </div>
              <p className="text-sm leading-relaxed text-zinc-400">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
